import { DashboardVisitors } from "./DashboardVisitors";

export const Visitors = () => {
  return <DashboardVisitors />;
};
